import { render } from "./LayoutSidebarBody.vue?vue&type=template&id=f4409d8e"
const script = {}

import "./LayoutSidebarBody.vue?vue&type=style&index=0&id=f4409d8e&lang=postcss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__